import useGetApi from 'src/api/useGetApi';

const useAzureCallback = (code?: string) => {
  return useGetApi<void>({
    endpoint: 'oauth/azure/callback',
    queryParameters: { code },
    options: {
      enabled: !!code,
    },
  });
};

export default useAzureCallback;
